let timescaleFormat = function(value) {
  if (value === null || value === '') {
    return 'N/A';
  } else if (value === 'ASAP') {
    return value;
  } else {
    return value.toLowerCase().split(/([0-9]+)/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
};

export default {
  install: function (Vue) {
    Vue.filter('timescale', timescaleFormat);
  }
}
